import "./BtnCard.scss";
import { motion } from "framer-motion";

const BtnCard = ({ icon, title, subTitle, clickHandler }) => {
  return (
    <div className="footer_btn">
      <motion.div
        initial={{ scaleX: 0.6, opacity: 0 }}
        whileInView={{ scaleX: 1, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.1,
        }}
        className="btn_card"
        onClick={clickHandler}
      >
        <div className="text">
          <p className="darkGold">
            <b>{title}</b>
          </p>
          <p className="light darkGold">{subTitle}</p>
        </div>
        <div className="icon_wrap">{icon}</div>
      </motion.div>
      <motion.div
        initial={{ scaleX: 0.6, opacity: 0 }}
        whileInView={{ scaleX: 1, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.2,
        }}
        className="strip a"
      ></motion.div>
      <motion.div
        initial={{ scaleX: 0.6, opacity: 0 }}
        whileInView={{ scaleX: 1, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.4,
        }}
        className="strip b"
      ></motion.div>
      <motion.div
        initial={{ scaleX: 0.6, opacity: 0 }}
        whileInView={{ scaleX: 1, opacity: 1 }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.6,
        }}
        className="strip c"
      ></motion.div>
    </div>
  );
};

export default BtnCard;
